import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=cc7a5a70&scoped=true"
import script from "./EmailTemplates.vue?vue&type=script&lang=ts"
export * from "./EmailTemplates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7a5a70",
  null
  
)

export default component.exports